import { Option } from "./common";

export enum BaseLoadTypesEnum {
  drayage = "Drayage",
  dryvan = "Dryvan",
  flatbed = "Flatbed",
  stepdeck = "Stepdeck",
  reefer = "Reefer",
  cargovan = "Cargovan",
  hotshot = "Hotshot",
  powerOnly = "PowerOnly",
  straightBoxTruck = "StraightBoxTruck",
}

export enum FullLoadTypesEnum {
  drayage = "Drayage",
  drayageWithHazmat = "DrayageWithHazmat",
  dryvan = "Dryvan",
  dryvanWithHazmat = "DryvanWithHazmat",
  stepdeck = "Stepdeck",
  stepdeckWithHazmat = "StepdeckWithHazmat",
  flatbed = "Flatbed",
  flatbedWithHazmat = "FlatbedWithHazmat",
  reefer = "Reefer",
  reeferWithHazmat = "ReeferWithHazmat",
  cargovan = "Cargovan",
  cargovanWithHazmat = "CargovanWithHazmat",
  hotshot = "Hotshot",
  hotshotWithHazmat = "HotshotWithHazmat",
  powerOnly = "PowerOnly",
  powerOnlyWithHazmat = "PowerOnlyWithHazmat",
  straightBoxTruck = "StraightBoxTruck",
  straightBoxTruckWithHazmat = "StraightBoxTruckWithHazmat",
}

export enum LoadTypeTranslationEnum {
  drayage = "Drayage",
  drayageWithHazmat = "Drayage + Hazmat",
  dryvan = "Dryvan",
  dryvanWithHazmat = "Dryvan + Hazmat",
  flatbed = "Flatbed",
  flatbedWithHazmat = "Flatbed + Hazmat",
  stepdeck = "Stepdeck",
  stepdeckWithHazmat = "Stepdeck + Hazmat",
  reefer = "Reefer",
  reeferWithHazmat = "Reefer + Hazmat",
  cargovan = "Cargovan",
  cargovanWithHazmat = "Cargovan + Hazmat",
  hotshot = "Hotshot",
  hotshotWithHazmat = "Hotshot + Hazmat",
  powerOnly = "Power Only",
  powerOnlyWithHazmat = "Power Only + Hazmat",
  straightBoxTruck = "Straight Box Truck",
  straightBoxTruckWithHazmat = "Straight Box Truck + Hazmat",
}

export const LoadTypeLabel = {
  [FullLoadTypesEnum.drayage]: LoadTypeTranslationEnum.drayage,
  [FullLoadTypesEnum.drayageWithHazmat]:
    LoadTypeTranslationEnum.drayageWithHazmat,
  [FullLoadTypesEnum.dryvan]: LoadTypeTranslationEnum.dryvan,
  [FullLoadTypesEnum.dryvanWithHazmat]:
    LoadTypeTranslationEnum.dryvanWithHazmat,
  [FullLoadTypesEnum.stepdeck]: LoadTypeTranslationEnum.stepdeck,
  [FullLoadTypesEnum.stepdeckWithHazmat]:
    LoadTypeTranslationEnum.stepdeckWithHazmat,
  [FullLoadTypesEnum.flatbed]: LoadTypeTranslationEnum.flatbed,
  [FullLoadTypesEnum.flatbedWithHazmat]:
    LoadTypeTranslationEnum.flatbedWithHazmat,
  [FullLoadTypesEnum.reefer]: LoadTypeTranslationEnum.reefer,
  [FullLoadTypesEnum.reeferWithHazmat]:
    LoadTypeTranslationEnum.reeferWithHazmat,
  [FullLoadTypesEnum.cargovan]: LoadTypeTranslationEnum.cargovan,
  [FullLoadTypesEnum.cargovanWithHazmat]:
    LoadTypeTranslationEnum.cargovanWithHazmat,
  [FullLoadTypesEnum.hotshot]: LoadTypeTranslationEnum.hotshot,
  [FullLoadTypesEnum.hotshotWithHazmat]:
    LoadTypeTranslationEnum.hotshotWithHazmat,
  [FullLoadTypesEnum.powerOnly]: LoadTypeTranslationEnum.powerOnly,
  [FullLoadTypesEnum.powerOnlyWithHazmat]:
    LoadTypeTranslationEnum.powerOnlyWithHazmat,
  [FullLoadTypesEnum.straightBoxTruck]:
    LoadTypeTranslationEnum.straightBoxTruck,
  [FullLoadTypesEnum.straightBoxTruckWithHazmat]:
    LoadTypeTranslationEnum.straightBoxTruckWithHazmat,
};

export const OTR_LOAD_TYPE_OPTIONS: Option[] = [
  {
    label: LoadTypeLabel[BaseLoadTypesEnum.reefer],
    value: BaseLoadTypesEnum.reefer,
  },
  {
    label: LoadTypeLabel[BaseLoadTypesEnum.dryvan],
    value: BaseLoadTypesEnum.dryvan,
  },
  {
    label: LoadTypeLabel[BaseLoadTypesEnum.flatbed],
    value: BaseLoadTypesEnum.flatbed,
  },
  {
    label: LoadTypeLabel[BaseLoadTypesEnum.stepdeck],
    value: BaseLoadTypesEnum.stepdeck,
  },
  {
    label: LoadTypeLabel[BaseLoadTypesEnum.cargovan],
    value: BaseLoadTypesEnum.cargovan,
  },
  {
    label: LoadTypeLabel[BaseLoadTypesEnum.hotshot],
    value: BaseLoadTypesEnum.hotshot,
  },
  {
    label: LoadTypeLabel[BaseLoadTypesEnum.powerOnly],
    value: BaseLoadTypesEnum.powerOnly,
  },
  {
    label: LoadTypeLabel[BaseLoadTypesEnum.straightBoxTruck],
    value: BaseLoadTypesEnum.straightBoxTruck,
  },
];

export const OTR_FULL_LOAD_TYPE_OPTIONS: Option[] = [
  {
    label: LoadTypeLabel[FullLoadTypesEnum.reefer],
    value: FullLoadTypesEnum.reefer,
  },
  {
    label: LoadTypeLabel[FullLoadTypesEnum.reeferWithHazmat],
    value: FullLoadTypesEnum.reeferWithHazmat,
  },
  {
    label: LoadTypeLabel[FullLoadTypesEnum.dryvan],
    value: FullLoadTypesEnum.dryvan,
  },
  {
    label: LoadTypeLabel[FullLoadTypesEnum.dryvanWithHazmat],
    value: FullLoadTypesEnum.dryvanWithHazmat,
  },
  {
    label: LoadTypeLabel[FullLoadTypesEnum.flatbed],
    value: FullLoadTypesEnum.flatbed,
  },
  {
    label: LoadTypeLabel[FullLoadTypesEnum.flatbedWithHazmat],
    value: FullLoadTypesEnum.flatbedWithHazmat,
  },
  {
    label: LoadTypeLabel[FullLoadTypesEnum.stepdeck],
    value: FullLoadTypesEnum.stepdeck,
  },
  {
    label: LoadTypeLabel[FullLoadTypesEnum.stepdeckWithHazmat],
    value: FullLoadTypesEnum.stepdeckWithHazmat,
  },
  {
    label: LoadTypeLabel[FullLoadTypesEnum.cargovan],
    value: FullLoadTypesEnum.cargovan,
  },
  {
    label: LoadTypeLabel[FullLoadTypesEnum.cargovanWithHazmat],
    value: FullLoadTypesEnum.cargovanWithHazmat,
  },
  {
    label: LoadTypeLabel[FullLoadTypesEnum.hotshot],
    value: FullLoadTypesEnum.hotshot,
  },
  {
    label: LoadTypeLabel[FullLoadTypesEnum.hotshotWithHazmat],
    value: FullLoadTypesEnum.hotshotWithHazmat,
  },
  {
    label: LoadTypeLabel[FullLoadTypesEnum.powerOnly],
    value: FullLoadTypesEnum.powerOnly,
  },
  {
    label: LoadTypeLabel[FullLoadTypesEnum.powerOnlyWithHazmat],
    value: FullLoadTypesEnum.powerOnlyWithHazmat,
  },
  {
    label: LoadTypeLabel[FullLoadTypesEnum.straightBoxTruck],
    value: FullLoadTypesEnum.straightBoxTruck,
  },
  {
    label: LoadTypeLabel[FullLoadTypesEnum.straightBoxTruckWithHazmat],
    value: FullLoadTypesEnum.straightBoxTruckWithHazmat,
  },
];

export interface DefaultDrayageTariffPricingTier {
  id: number;
  name: string;
}

export interface LoadTypeConfiguration {
  hasDrayage: boolean;
  hasDryvan: boolean;
  hasFlatbed: boolean;
  hasStepdeck: boolean;
  hasReefer: boolean;
  hasCargovan: boolean;
  hasHotshot: boolean;
  hasPowerOnly: boolean;
  hasStraightBoxTruck: boolean;
  isHazmatCertified: boolean;
  defaultLoadType?: BaseLoadTypesEnum;
  defaultOTRRate: number;
  defaultDrayageTariffPricingTier: DefaultDrayageTariffPricingTier | null;
}
